module.exports = __webpack_public_path__ + "22efa2a59050b9067dd5311928a64fd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_40.jpg
// module id = 1780
// module chunks = 5